import ReactDOM from "react-dom";
import React, { useState, useContext, useEffect, useRef } from "react";
import objects from "../../objects";
import "./Modal.scss";
import "../Button/Button.scss";
import grass from "../../assets/tr1.jpg";
import tree_mini from "../../assets/trees/grupa_tree.png";
import { BuildingsContext } from "../../bContext";
import arrow from "../../assets/rarr.svg";
import arrow_orange from "../../assets/larr.svg";
import micro from "../../assets/microscope.png";
import pause from "../../assets/pause-button.svg";
import pauseOrange from "../../assets/pause-orange.svg";
import backBlue from "../../assets/tostart.svg";
import backOrange from "../../assets/tostart2.svg";
import snd from "../../assets/sounds/01.mp3";

// import ReactPlayer from "react-player";
import Sound from "react-sound";

const Modal = ({ isShowing, hide, props }) => {
  const {switchToEnglish, repeat, setRepeat, which, setWhich, autoPre, setAutoPre, page, setPage,speakVol, setSpeakVol, modalPlaying,setPageRoad, setModalPlaying } = useContext(
    BuildingsContext
  );
  const [anime, setAnime] = useState(0);
  const [anime2, setAnime2] = useState(0);

  const [whichImg, setWhichImg] = useState(0);
  const [whichVid, setWhichVid] = useState(0);
  const [left, setLeft] = useState(0);
  const [right, setRight] = useState(0);
  const [play, setPlay] = useState(true);
  const [playColor, setPlayColor] = useState(false);
  const [start, setStart] = useState(false);
  const [checkOnEnded, setCheckOnEnded] = useState(false);

  const [modalPage2, setModalPage2] = useState(1);
  const [maxModalPage2, setmaxModalPage2] = useState(0);

  const [modalVid, setModalVid] = useState(1);
  const [maxModalVid, setmaxModalVid] = useState(0);

  const [isPlaying, setIsPlaying] = useState();
  const [isEnded, setIsEnded] = useState(false);
 

  const [autoHide, setAutoHide] = useState(false);

  const vidRef = useRef(null);

  const handlePlayVideo = () => {
    vidRef.current.play();
  };
  const handleStopVideo = () => {
    vidRef.current.pause();
  };
  const handleStartVideo = () => {
    vidRef.current.currentTime = 0;
  };
  const handleLoadVideo = () => {
    vidRef.current.load();
  };

  const animateLeft = () => {
    setAnime(1);

    setTimeout(() => setAnime(0), 700);
  };

  const animateRight = () => {
    setAnime(2);

    setTimeout(() => setAnime(0), 700);
  };

  const animateLeft2 = () => {
    setAnime2(1);

    setTimeout(() => setAnime2(0), 700);
  };

  const animateRight2 = () => {
    setAnime2(2);

    setTimeout(() => setAnime2(0), 700);
  };

  useEffect(() => {
    objects.find((el) => {
      if (el.id === which) {
        setmaxModalPage2(el.images.length);
        setmaxModalVid(el.videos.length);
      }
    });
  }, [which]);

  function usePrevious(value) {
    const ref = useRef();
    useEffect(() => {
      ref.current = value;
    });
    return ref.current;
  }

  useEffect(() => {
    if (autoPre === true) {
      if (page === 0 && isPlaying !== undefined) {
        const timer = setTimeout(() => setPage(1), isPlaying + 500);
        setWhichImg(0);
        setModalPage2(1);
        return () => clearTimeout(timer);
      }
      if (modalPage2 !== maxModalPage2 && page === 1) {
        const timer2 = setTimeout(() => {
          setModalPage2(modalPage2 + 1);
          setWhichImg(whichImg + 1);
        }, 2000);
        return () => clearTimeout(timer2);
      }
      if (modalPage2 === maxModalPage2 && page === 1) {
        const timer3 = setTimeout(() => {
          setPage(2);
        }, 1000);
        return () => clearTimeout(timer3);
      }
      if (page === 2) {
        const timer4 = setTimeout(() => {
          if (
            modalVid >= maxModalVid &&
            checkOnEnded === true &&
            which !== 21
          ) {
            setWhich(which + 1);
            setPage(0);
            setWhichImg(0);
            setModalPage2(1);
            setWhichVid(0);
            setModalVid(1);
            return maxModalVid;
          } else if (
            modalVid >= maxModalVid &&
            checkOnEnded === true &&
            which === 21
          ) {
            setAutoPre(false);
            setPage(0);
            setWhichImg(0);
            setModalPage2(1);
            setWhichVid(0);
            setModalVid(1);
            hide();
          } else if (modalVid < maxModalVid && checkOnEnded === true) {
            setWhichVid(whichVid + 1);
            setModalVid(modalVid + 1);
            handleLoadVideo();
          }
        }, 2000);
        return () => clearTimeout(timer4);
      }
    }
  }, [
    autoPre,
    checkOnEnded,
    isPlaying,
    maxModalPage2,
    maxModalVid,
    modalPage2,
    modalVid,
    page,
    setAutoPre,
    setPage,
    setWhich,
    which,
    whichImg,
    whichVid,
  ]);

  // useEffect(() => {
  //   if (checkOnEnded === true && autoPre === true && which !== 21) {
  //     setWhich(which + 1);
  //     which !== 21 && animateRight();
  //     which !== 21 && setPage(0);
  //     setWhichImg(0);
  //     setModalPage2(1);
  //     setWhichVid(0);
  //     setModalVid(1);
  //   }
  // }, [autoPre, checkOnEnded]);

  // console.log(page, modalPage2, maxModalPage2, whichImg)

  return isShowing
    ? ReactDOM.createPortal(
        <React.Fragment>
          <div className="modal-overlay" />

          <div
            className={
              (anime === 0 && "modal-wrapper") ||
              (anime === 1 && "trans modal-wrapper") ||
              (anime === 2 && "trans2 modal-wrapper")
            }
          >
            {which !== 1 && (
              <div
                className="triangle-left"
                onClick={() => {
                  which >= 2 && setWhich(which - 1);
                  which >= 2 && animateLeft();
                  which >= 2 && setPage(0);
                  setWhichImg(0);
                  setModalPage2(1);
                  setWhichVid(0);
                  setModalVid(1);
                  setRepeat(Sound.status.PLAYING)
                }}
              >
                <div className="inner-triangle"></div>
              </div>
            )}
            {which !== 21 && (
              <div
                className="triangle-right"
                onClick={() => {
                  which !== 21 && setWhich(which + 1);
                  which !== 21 && animateRight();
                  which !== 21 && setPage(0);
                  setWhichImg(0);
                  setWhichVid(0);
                  setModalVid(1);
                  setModalPage2(1);
                  setRepeat(Sound.status.PLAYING)
                }}
              >
                <div className="inner-triangle-right-mod"></div>
              </div>
            )}
            <div className="mini-header">
              {objects.map(
                (el) => el.id === which && <h3 key={el.id}>{switchToEnglish === false ? el.title : el.titleEn}</h3>
              )}
            </div>
            <div className="mini-buttons">
              <div className="over_button">
                <div
                  className={page === 0 ? "button-big active" : "button-big"}
                  onClick={() => {
                    setPage(0);
                    setWhichImg(0);
                    setWhichVid(0);
                    setModalPage2(1);
                    setModalVid(1);
                  }}
                >
                  <span
                    className={
                      page === 0 ? "button-small active" : "button-small"
                    }
                  >
                    {!switchToEnglish ? " OPIS" : "DESCRIPTION"}
                   
                  </span>
                </div>
              </div>
              <div className="over_button">
                <div
                  className={page === 1 ? "button-big active" : "button-big"}
                  onClick={() => {
                    setPage(1);
                    setModalPlaying(false)
                  }}
                >
                  <span
                    className={
                      page === 1 ? "button-small active" : "button-small"
                    }
                  >
                   {!switchToEnglish ? " ZDJĘCIA" : "PHOTOS"}
                  </span>
                </div>
              </div>
              <div className="over_button">
                <div
                  className={page === 2 ? "button-big active" : "button-big"}
                  onClick={() => {
                    setPage(2);
                    setWhichImg(0);
                    setWhichVid(0);
                    setModalVid(1);
                    setModalPage2(1);
                    setModalPlaying(false)
                  }}
                >
                  <span
                    className={
                      page === 2 ? "button-small active" : "button-small"
                    }
                  >
                    {!switchToEnglish ? "FILM" : "VIDEO"}
                  </span>
                </div>
              </div>
            </div>

            <div
              onClick={() => {
                hide();
                setPage(0);
                setWhichImg(0);
                setModalPage2(1);
                setAutoPre(false);
                setPage(0);
                setWhichVid(0);
                setModalPlaying(false)
                setPageRoad(0)
              }}
              className="mini-exit"
            >
              <svg
                className="xsvg"
                height="365.696pt"
                viewBox="0 0 365.696 365.696"
                width="365.696pt"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="m243.1875 182.859375 113.132812-113.132813c12.5-12.5 12.5-32.765624 0-45.246093l-15.082031-15.082031c-12.503906-12.503907-32.769531-12.503907-45.25 0l-113.128906 113.128906-113.132813-113.152344c-12.5-12.5-32.765624-12.5-45.246093 0l-15.105469 15.082031c-12.5 12.503907-12.5 32.769531 0 45.25l113.152344 113.152344-113.128906 113.128906c-12.503907 12.503907-12.503907 32.769531 0 45.25l15.082031 15.082031c12.5 12.5 32.765625 12.5 45.246093 0l113.132813-113.132812 113.128906 113.132812c12.503907 12.5 32.769531 12.5 45.25 0l15.082031-15.082031c12.5-12.503906 12.5-32.769531 0-45.25zm0 0" />
              </svg>
            </div>

            {which === 8 &&
              (modalPage2 === 2 ||
                modalPage2 === 3 ||
                modalPage2 === 4 ||
                modalVid === 3) && (
                <div className="micro-cont2">
                  <img src={micro} alt="microscope" />
                </div>
              )}

            <div className="modal">
              {page === 0 && (
                <>
                  <div className="mini-img">
                    <img className="tree_mini" src={tree_mini} alt="" />
                    {/* <img className="grass" src={grass} alt="" /> */}
                    {objects.map(
                      (el) =>
                        el.id === which && (
                          <div key={el.id} className={el.id === 6 || el.id === 9 || el.id === 8 || el.id === 21 ?  "okienko-cont" : ""} key={el.id}>
                            {autoPre && (
                              <Sound
                              key={`${el.id}sadas`}
                                url={switchToEnglish ? el.audioen : el.audio}
                                playStatus={repeat}
                                onPlaying={(el) =>
                                  {
                                    setIsPlaying(Math.ceil(el.duration));
                                    if(speakVol > 0 ) {
                                      setModalPlaying(true)
                                    }
                                  
                                }
                                }
                                volume={speakVol}
                                //  onPlaying={(el) => console.log(el.duration)}
                                onFinishedPlaying={() =>  {
                                  setModalPlaying(false)
                                  setRepeat(Sound.status.STOPPED)}
                                }
                              />
                            )}
                            {!autoPre && (
                               <Sound
                               key={`${el.id}gxxx`}
                               url={switchToEnglish ? el.audioen : el.audio}
                               playStatus={repeat}
                               onPlaying={(el) =>
                                {
                                  setIsPlaying(Math.ceil(el.duration));
                                  if(speakVol > 0 ) {
                                    setModalPlaying(true)
                                  }
                                
                                }
                               
                                 
                               }
                               
                               volume={speakVol}
                               //  onPlaying={(el) => console.log(el.duration)}
                               onFinishedPlaying={() => 
                               {
                                setRepeat(Sound.status.STOPPED);
                                setModalPlaying(false);
                               } 
                              }
                             />
                            )}
                            <img
                              key={`${el.id}g`}
                              className={`model_img ${
                                el.class2 || "model_sclass"
                              }`}
                              src={
                                el.model_kotly !== undefined
                                  ? el.model_kotly
                                  : el.model
                              }
                              alt=""
                            />
                            {el.spinBr  && (
                           
                               <img className="spinner" src={el.spinBr[0].spin[0]} alt="" />
                            )}
                            {el.water && (
                            <>
                             <img key={`${el.id}gxz`} className="wodo1 wdgif" src={el.water} alt=""/>
                             <img key={`${el.id}gasda`} className="wodo2 wdgif" src={el.water} alt=""/>
                             <img key={`${el.id}gas`} className="wodo3 wdgif" src={el.water} alt=""/>
                             <img  key={`${el.id}gqw`} className="wodo4 wdgif" src={el.water} alt=""/>
                             </>
                            )
                            }
                            {el.flames && <img key={`${el.id}gaas`} className="flame_mod" src={el.flames} alt=''/> }
                            
                          </div>
                        )
                    )}
                  </div>
                  <div className="desc">
                    {objects.map(
                      (el) =>
                        el.id === which && (
                          <>
                            <p
                              key={el.id}
                              dangerouslySetInnerHTML={{
                                __html: switchToEnglish === false ?  el.description : el.descriptionEn,
                              }}
                            ></p>
                            {el.microDesc !== undefined && (
                              <div key={`${el.id}a`} className="star-cont">
                                <span
                                  key={`${el.id}b`}
                                  dangerouslySetInnerHTML={{
                                    __html: el.microDesc,
                                  }}
                                ></span>
                                <div key={`${el.id}c`} className="micro-cont">
                                  <img
                                    key={`${el.id}x`}
                                    src={micro}
                                    alt="microscope"
                                  />
                                </div>
                              </div>
                            )}
                          </>
                        )
                    )}
                  </div>
                  <div className="modal-header"></div>
                  <div className="modalbtn"></div>
                  <div className="defaultbtn"></div>

                  <div
                    className="mini-repeat"
                    onClick={() => {
                      if(autoPre) {
                        setRepeat(Sound.status.STOPPED);
                        setAutoPre(false);
                        setTimeout(() => {
                          setRepeat(Sound.status.PLAYING);
                          setAutoPre(true);
                        }, 1);
                      } else {
                        setRepeat(Sound.status.STOPPED);
                        
                        setTimeout(() => {
                          setRepeat(Sound.status.PLAYING);
                    
                        }, 1);
                      }
                    
                    }}
                  >
                    {!switchToEnglish ? (
                        <>
                         <p>POWTÓRZ</p>
                    <p>LEKTORA</p>
                        </>
                    ): (<p>REITERATE</p>)}
                   
                  </div>
                </>
              )}

              {page === 1 && (
                <>
                  <div
                    className={
                      (anime2 === 1 && "trans3 zdjecia") ||
                      (anime2 === 2 && "trans4 zdjecia") ||
                      (anime2 === 0 && "zdjecia")
                    }
                  >
                    {objects.map(
                      (el) =>
                        el.id === which && (
                          <div key={el.id}>
                            <img
                              key={`${el.id}h`}
                              src={el.images[whichImg]}
                              alt=""
                            />
                          </div>
                        )
                    )}
                  </div>
                  <div className="modal-header"></div>
                  <div className="modalbtn"></div>
                  <div className="defaultbtn"></div>
                  <div className="mini-repeat2">
                    <img
                      className={
                        modalPage2 === 1 ? "arrow_left opa" : "arrow_left"
                      }
                      src={left === 1 ? arrow_orange : arrow}
                      alt="arrow"
                      onMouseOver={() =>
                        modalPage2 === 1 ? setLeft(0) : setLeft(1)
                      }
                      onMouseLeave={() => setLeft(0)}
                      onClick={
                        () => {
                          if (modalPage2 <= 1) {
                            return 1;
                          } else {
                            setModalPage2(modalPage2 - 1);
                            setWhichImg(whichImg - 1);
                          }
                          animateLeft2();
                        }

                        // modalPage2 <= 1 ? 1 : setModalPage2(modalPage2 - 1)
                      }
                    />
                    <p>
                      {`${modalPage2}`}/{`${maxModalPage2}`}
                    </p>
                    {/* <div class="slick-next slick-arrow "></div> */}
                    <img
                      className={
                        modalPage2 === maxModalPage2 ? "opa" : "arrows"
                      }
                      src={right === 1 ? arrow_orange : arrow}
                      alt="arrow"
                      onMouseOver={() =>
                        modalPage2 === maxModalPage2 ? setRight(0) : setRight(1)
                      }
                      onMouseLeave={() => setRight(0)}
                      onClick={() => {
                        if (modalPage2 >= maxModalPage2) {
                          return maxModalPage2;
                        } else {
                          setWhichImg(whichImg + 1);
                          setModalPage2(modalPage2 + 1);
                        }
                        animateRight2();
                      }}
                      // modalPage2 >= maxModalPage2 ? maxModalPage2 : setModalPage2(modalPage2 + 1)
                    />
                  </div>
                </>
              )}

              {page === 2 && (
                <>
                  <div className="vid-cont">
                    {objects.map(
                      (el) =>
                        el.id === which && (
                          <video
                            key={el.id}
                            ref={vidRef}
                            autoPlay={true}
                            onEnded={() => setCheckOnEnded(true)}
                            onPlaying={() => setCheckOnEnded(false)}
                          >
                            <source
                              key={`${el.id}f`}
                              src={el.videos[whichVid]}
                              type="video/mp4"
                            />
                          </video>
                        )
                    )}
                  </div>
                  <div className="modal-header"></div>
                  <div className="modalbtn"></div>
                  <div className="defaultbtn"></div>

                  <div
                    className="play-pause"
                    onClick={() => {
                      if (play === false) {
                        handlePlayVideo();
                        setPlay(true);
                      } else if (play === true) {
                        handleStopVideo();
                        setPlay(false);
                      }
                    }}
                    onMouseOver={() => setPlayColor(true)}
                    onMouseLeave={() => setPlayColor(false)}
                  >
                    {play ? (
                      <img
                        className="start"
                        src={playColor ? arrow_orange : arrow}
                        alt="arrow"
                      />
                    ) : (
                      <img
                        className="pause"
                        src={playColor ? pauseOrange : pause}
                        alt="arrow"
                      />
                    )}

                    {/* <button onClick={() => handleStopVideo()}>
                      sassssstop
                    </button> */}
                  </div>
                  <div
                    className="toTheStart"
                    onClick={() => handleStartVideo()}
                    onMouseOver={() => setStart(true)}
                    onMouseLeave={() => setStart(false)}
                  >
                    <img src={start ? backOrange : backBlue} alt="backblue" />
                  </div>

                  <div className="mini-repeat2">
                    <img
                      className={
                        modalVid === 1 ? "arrow_left opa" : "arrow_left"
                      }
                      src={left === 1 ? arrow_orange : arrow}
                      alt="arrow"
                      onMouseOver={() =>
                        modalVid === 1 ? setLeft(0) : setLeft(1)
                      }
                      onMouseLeave={() => setLeft(0)}
                      onClick={
                        () => {
                          if (modalVid <= 1) {
                            return 1;
                          } else {
                            setModalVid(modalVid - 1);
                            setWhichVid(whichVid - 1);
                            handleLoadVideo();
                          }
                          animateLeft2();
                        }

                        // modalVid <= 1 ? 1 : setModalVid(modalVid - 1)
                      }
                    />
                    <p>
                      {`${modalVid}`}/{`${maxModalVid}`}
                    </p>
                    {/* <div class="slick-next slick-arrow "></div> */}
                    <img
                      className={modalVid === maxModalVid ? "opa" : "arrows"}
                      src={right === 1 ? arrow_orange : arrow}
                      alt="arrow2"
                      onMouseOver={() =>
                        modalVid === maxModalVid ? setRight(0) : setRight(1)
                      }
                      onMouseLeave={() => setRight(0)}
                      onClick={() => {
                        if (modalVid >= maxModalVid) {
                          return maxModalVid;
                        } else {
                          setWhichVid(whichVid + 1);
                          setModalVid(modalVid + 1);
                          handleLoadVideo();
                        }
                        animateRight2();
                      }}
                      // modalPage2 >= maxModalPage2 ? maxModalPage2 : setModalPage2(modalPage2 + 1)
                    />
                  </div>
                </>
              )}
            </div>
          </div>
        </React.Fragment>,
        document.body
      )
    : null;
};

export default Modal;
